import { useContextProvider } from "../page-context/ContextProvider";

const ToggleLanguageButton = () => {
  const { selectedLanguage, setSelectedLanguage } = useContextProvider();

  const isEn = selectedLanguage === "en";
  const isFr = selectedLanguage === "fr";

  // Golden Green for active, Muted White for inactive
  const activeBg = "#8eb33a";
  const activeText = "#08110d";
  const inactiveText = "rgba(255, 255, 255, 0.45)"; // Same as footer copyright

  return (
    <div className="footer-lang-pill">
      <button
        onClick={() => setSelectedLanguage("en")}
        className="footer-lang-btn"
        style={{
          background: isEn ? activeBg : "transparent",
          color: isEn ? activeText : inactiveText,
        }}
      >
        EN
      </button>
      <div className="footer-lang-divider" />
      <button
        onClick={() => setSelectedLanguage("fr")}
        className="footer-lang-btn"
        style={{
          background: isFr ? activeBg : "transparent",
          color: isFr ? activeText : inactiveText,
        }}
      >
        FR
      </button>
    </div>
  );
};

export default ToggleLanguageButton;




